export default {
  PersonalDetails: 1,
  Password: 2,
  Organisation: 3,
  Success: 4
};
